import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.set";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { dataCompare, dataCompare_currency, compare_currency_other, getEchearts, getEchearts_currency, compare_chart_currency_other } from "@/api/dataAll/dataCompare";
import * as echarts from "echarts";
export default {
  name: "dataCompare",
  mixins: [tabulation],
  data: function data() {
    return {
      more: true,
      PointTime: ['00', this.$times.theDay('HH') + ''],
      originaltableList: [],
      originaltableListP: [{
        name: this.$t('activateDevice'),
        key: 'activate_device'
      }, {
        name: this.$t('newDeviceRechargeAmount'),
        key: 'new_device_recharge_amount'
      }, {
        name: this.$t('newDeviceRechargeNum'),
        key: 'new_device_recharge_num'
      }, {
        name: this.$t('rechargeAmount'),
        key: 'recharge_amount'
      }, {
        name: this.$t('registerNum'),
        key: 'register_num'
      }, {
        name: this.$t('loginNum'),
        key: 'login_num'
      }, {
        name: this.$t('rechargeNum'),
        key: 'recharge_num'
      }, {
        name: this.$t('onlineNum'),
        key: 'online_num'
      }, {
        name: this.$t('arppu'),
        key: 'arppu'
      }, {
        name: this.$t('registerRechargePnum'),
        key: 'register_recharge_pnum'
      }, {
        name: this.$t('registerRechargeAmount'),
        key: 'register_recharge_amount'
      }],
      originaltableListVND: [{
        name: this.$t('activateDevice'),
        key: 'activate_device'
      }, {
        name: this.$t('newDeviceRechargeAmount'),
        key: 'new_device_recharge_amount'
      }, {
        name: this.$t('newDeviceRechargeAmountVnd'),
        key: 'new_device_recharge_amountexchange'
      }, {
        name: this.$t('newDeviceRechargeNum'),
        key: 'new_device_recharge_num'
      }, {
        name: this.$t('rechargeAmount'),
        key: 'recharge_amount'
      }, {
        name: this.$t('rechargeAmountVnd'),
        key: 'recharge_amountexchange'
      }, {
        name: this.$t('registerNum'),
        key: 'register_num'
      }, {
        name: this.$t('loginNum'),
        key: 'login_num'
      }, {
        name: this.$t('rechargeNum'),
        key: 'recharge_num'
      }, {
        name: this.$t('onlineNum'),
        key: 'online_num'
      }, {
        name: this.$t('arppu'),
        key: 'arppu'
      }, {
        name: this.$t('registerRechargePnum'),
        key: 'register_recharge_pnum'
      }, {
        name: this.$t('registerRechargeAmount'),
        key: 'register_recharge_amount'
      }, {
        name: this.$t('registerRechargeAmountVnd'),
        key: 'register_recharge_amountexchange'
      }],
      originaltableListUSD: [{
        name: this.$t('activateDevice'),
        key: 'activate_device'
      }, {
        name: this.$t('newDeviceRechargeAmount'),
        key: 'new_device_recharge_amount'
      }, {
        name: this.$t('newDeviceRechargeAmountUsd'),
        key: 'new_device_recharge_amountexchange'
      }, {
        name: this.$t('newDeviceRechargeNum'),
        key: 'new_device_recharge_num'
      }, {
        name: this.$t('rechargeAmount'),
        key: 'recharge_amount'
      }, {
        name: this.$t('rechargeAmountUsd'),
        key: 'recharge_amountexchange'
      }, {
        name: this.$t('registerNum'),
        key: 'register_num'
      }, {
        name: this.$t('loginNum'),
        key: 'login_num'
      }, {
        name: this.$t('rechargeNum'),
        key: 'recharge_num'
      }, {
        name: this.$t('onlineNum'),
        key: 'online_num'
      }, {
        name: this.$t('arppu'),
        key: 'arppu'
      }, {
        name: this.$t('registerRechargePnum'),
        key: 'register_recharge_pnum'
      }, {
        name: this.$t('registerRechargeAmount'),
        key: 'register_recharge_amount'
      }, {
        name: this.$t('registerRechargeAmountUsd'),
        key: 'register_recharge_amountexchange'
      }],
      tableList: [],
      screen: [],
      tableData: [],
      value2: [],
      searchData: {
        days: "1",
        time: ""
      },
      dates: [],
      rawDatatow: {},
      series_arr: [],
      dateShowTitle: [],
      selected: {},
      name: 'dataCompare'
    };
  },
  created: function created() {
    this.getsearchDate();
  },
  methods: {
    getsearchDate: function getsearchDate() {
      var now = Date.parse(new Date(this.$times.zeroTimeZone()));
      console.log("now===", now);
      this.value2[0] = now;
      this.value2[1] = now;
    },
    screenControls: function screenControls() {
      var _this = this;

      var lengths = 0;

      var datas = _objectSpread(_objectSpread({}, JSON.parse(JSON.stringify(this.rawDatatow))), {}, {
        summary: {}
      });

      for (var k in datas.data) {
        if (!datas.summary[k]) {
          datas.summary[k] = {};
        }

        var hd = _objectSpread({}, datas.data[k]);

        for (var j in hd) {
          for (var ji in hd[j]) {
            if (!datas.summary[k][ji]) {
              datas.summary[k][ji] = 0;
            }

            datas.summary[k][ji] = datas.summary[k][ji] + Number(hd[j][ji]);
            datas.summary[k]['arppu'] = datas.summary[k]['recharge_num'] ? datas.summary[k]['recharge_amount'] / datas.summary[k]['recharge_num'] : 0;
          }
        }
      }

      this.originaltableList.forEach(function (i) {
        _this[i.key] = [];
      });

      for (var i in datas.data) {
        lengths = Object.keys(datas.data[i]);
        datas.data[i][this.$t('total')] = datas.summary[i];
      }

      var initialize = datas.data;
      var tableData = [];
      var tableList = [];
      var knum = -1;
      this.series_arr = [];
      this.dates = [];
      var screen = [];
      this.originaltableList.map(function (item) {
        if (_this.screen.findIndex(function (t) {
          return t == item.key;
        }) > -1) {
          screen.push(item);
        }
      });
      screen.forEach(function (item) {
        tableList.push({
          label: item.name,
          prop: item.key,
          list: []
        });
      });
      console.log("initialize", initialize); // 表格头部数据处理

      var _loop = function _loop(_i) {
        _this.dateShowTitle.push(_i);

        var d = {};

        for (var _k in initialize[_i]) {
          var c = _k.substring(0, 1) == "0" ? _k.substring(1, 2) : _k;
          d[c] = initialize[_i][_k];
          d[c]['date'] = _i;
        }

        tableList.map(function (item) {
          item.list.push({
            label: _i,
            prop: item.prop + _i
          });
        }); // 表格数据处理

        for (var _k2 in d) {
          knum += 1;
          var h = parseInt(_k2) + 1;
          tableData.push({
            hours: _k2 == _this.$t('total') ? _this.$t('total') : (_k2 < 10 ? '0' + _k2 : _k2) + '~' + (h < 10 ? '0' + h : h) + '点'
          });
          d[_k2]['recharge_amountexchange'] = Number(d[_k2]['recharge_amount']) * _this.exchangeRate;
          d[_k2]['register_recharge_amountexchange'] = Number(d[_k2]['register_recharge_amount']) * _this.exchangeRate;
          d[_k2]['new_device_recharge_amountexchange'] = Number(d[_k2]['new_device_recharge_amount']) * _this.exchangeRate;

          for (var _j in d[_k2]) {
            var text = d[_k2][_j];

            if (_j == 'recharge_amount' || _j == 'register_recharge_amount' || _j == 'arppu' || _j == 'new_device_recharge_amount' || _j == 'recharge_amountexchange' || _j == 'register_recharge_amountexchange' || _j == 'new_device_recharge_amountexchange') {
              if (_j == 'new_device_recharge_amount' || _j == 'recharge_amount' || _j == 'register_recharge_amount' || _j == 'recharge_amountexchange' || _j == 'register_recharge_amountexchange' || _j == 'new_device_recharge_amountexchange') {
                text = _this.isyjfmvnd() ? Number(d[_k2][_j]).toFixed(3) : _this.$utils.conversion(d[_k2][_j]).toFixed(2);
              } else {
                text = _this.$utils.conversion(d[_k2][_j]).toFixed(2);
              }
            }

            tableData[knum][_j + d[_k2]['date']] = text;
          }

          if (knum == lengths.length) {
            knum = -1;
          }
        }
      };

      for (var _i in initialize) {
        _loop(_i);
      }

      var _loop2 = function _loop2(_i2) {
        if (_this.dates.length < Object.keys(initialize[_i2]).length) {
          var hoursL = Object.keys(initialize[_i2]);
          hoursL.pop();
          hoursL.sort();
          hoursL.forEach(function (h) {
            var a = parseInt(h) + 1 < 10 ? "0".concat(parseInt(h) + 1) : parseInt(h) + 1;

            _this.dates.push(h + "~" + a + _this.$t('pointHourSuffix'));
          });
        }

        _this.originaltableList.forEach(function (j) {
          var obj = {
            name: j.name,
            type: "bar",
            data: [],
            date: _i2,
            emphasis: {
              focus: 'series'
            },
            itemStyle: {
              normal: {
                lineStyle: {},
                label: {
                  // show:true,
                  formatter: function formatter(params) {}
                }
              }
            }
          };
          var newArr = Object.keys(initialize[_i2]).sort();
          newArr.forEach(function (k) {
            var text = initialize[_i2][k][j.key];

            if (j == 'recharge_amount' || j == 'register_recharge_amount' || j == 'arppu' || j == 'new_device_recharge_amount' || j == 'recharge_amountexchange' || j == 'register_recharge_amountexchange' || j == 'new_device_recharge_amountexchange') {
              if (j == 'new_device_recharge_amount' || j == 'recharge_amount' || j == 'register_recharge_amount' || j == 'recharge_amountexchange' || j == 'register_recharge_amountexchange' || j == 'new_device_recharge_amountexchange') {
                text = _this.isyjfmvnd() ? d[k][j] : _this.$utils.conversion(d[k][j]).toFixed(2);
              } else {
                text = _this.$utils.conversion(d[k][j]).toFixed(2);
              }
            }

            if (k != _this.$t('total')) {
              obj.data.push(text);
            }
          });

          _this.series_arr.push(obj);
        });
      };

      for (var _i2 in initialize) {
        _loop2(_i2);
      }

      tableData.splice(lengths.length + 1, tableData.length - lengths.length + 1);
      tableList.unshift({
        label: '',
        list: [{
          label: this.$t('time'),
          prop: 'hours',
          width: 100
        }]
      });
      this.tableData = tableData;
      console.log("this.tableData==", this.tableData);
      this.tableList = tableList;
      console.log("this.tableList==", this.tableList);
      this.getechart();
    },
    searchClick: function searchClick() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.dataQuery(); // this.searchData.start_hour = this.PointTime[0]
                // this.searchData.end_hour = this.PointTime[1]


              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 数据请求操作
    dataQuery: function dataQuery() {
      var _this3 = this;

      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(resolve, reject) {
          var that, a, searchHoour, dbres, currentHour, currentDay, PointTimeend, startTime, endTime, reqFn, handleQueryData, PrimitiveList, dateList, cacheHourData, cacheHourObj, list, numt, queryData, hourDate, mathNum, queryDataT, defaultData;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  that = _this3;
                  a = _this3.$times.intervalTime(Date.parse(_this3.value2[0]), Date.parse(_this3.value2[1])) + 1;
                  _this3.searchData.kind = 1;

                  if (!(a <= 13)) {
                    _context3.next = 8;
                    break;
                  }

                  _this3.searchData.days = a;
                  _this3.searchData.time = _this3.value2[0];
                  _context3.next = 12;
                  break;

                case 8:
                  _this3.$message({
                    showClose: true,
                    message: _this3.$t('onlyQueryWithin13Days'),
                    type: "warning"
                  });

                  _this3.searchData.days = 1;
                  _this3.show = false;
                  return _context3.abrupt("return");

                case 12:
                  _this3.reqLoading = true;
                  _this3.dateShowTitle = [];
                  searchHoour = [];

                  _this3.hourList.forEach(function (i) {
                    if (i >= parseInt(_this3.PointTime[0]) && i <= _this3.PointTime[1]) {
                      var h = i < 10 ? "0".concat(i) : i;
                      searchHoour.push(h);
                    }
                  }); // 从数据库获取数据


                  _context3.next = 18;
                  return _this3.$DBControls.get(_this3.name + _this3.dataConvert() + JSON.stringify(_this3.PointTime));

                case 18:
                  dbres = _context3.sent;

                  if (!(dbres && dbres.code == 500)) {
                    _context3.next = 22;
                    break;
                  }

                  that.searchClick();
                  return _context3.abrupt("return");

                case 22:
                  // 获取当前小时
                  currentHour = _this3.$times.theDay('HH');
                  currentDay = _this3.$times.theDay();
                  console.log("currentDay===", currentDay);
                  PointTimeend = parseInt(_this3.PointTime[1]);
                  console.log("PointTimeend===", PointTimeend);
                  console.log("currentHour===", currentHour);
                  startTime = _this3.value2[0];
                  endTime = _this3.value2[1];
                  reqFn = dataCompare;

                  if (_this3.currencyClose && !_this3.searchData.pay_channel) {
                    reqFn = dataCompare_currency;
                  } else if (_this3.searchData.pay_channel) {
                    reqFn = compare_currency_other;
                  }

                  _context3.next = 34;
                  return _this3.getexchangeRate();

                case 34:
                  if (_this3.queryCurrency == 'VND') {
                    _this3.originaltableList = _this3.originaltableListUSD;
                  } else if (_this3.queryCurrency == 'USD') {
                    _this3.originaltableList = _this3.originaltableListP;
                  } else {
                    _this3.originaltableList = _this3.originaltableListP;
                  }

                  _this3.screen = _this3.originaltableList.map(function (item) {
                    return item.key;
                  }); // 数据处理函数

                  handleQueryData = function handleQueryData(queryData) {
                    console.log("queryData===", queryData);
                    var dataToUpdate = {};

                    var PrimitiveList = _this3.$times.getDayAll(startTime, endTime);

                    PrimitiveList.forEach(function (i) {
                      dataToUpdate[i] = queryData.data[i];
                    });
                    var dataNew = JSON.parse(JSON.stringify(dataToUpdate));
                    console.log("dataNew===", dataNew);
                    var currentHourList = {};

                    for (var k in dataNew[currentDay]) {
                      if (PointTimeend == currentHour) {
                        if (parseInt(k) < PointTimeend) {
                          currentHourList[k] = dataNew[currentDay][k];
                        }
                      } else {
                        if (parseInt(k) <= PointTimeend) {
                          currentHourList[k] = dataNew[currentDay][k];
                        }
                      }
                    }

                    var endData = _objectSpread({}, dataNew[currentDay]);

                    delete dataNew[currentDay];
                    var storeData = {
                      dataNew: _objectSpread({}, dataNew),
                      todayHoure: currentHourList,
                      houreDate: currentDay
                    };

                    _this3.$DBControls.update(_this3.name + _this3.dataConvert() + JSON.stringify(_this3.PointTime), storeData);

                    _this3.rawDatatow = {
                      data: dataToUpdate
                    };
                    _this3.reqLoading = false;

                    _this3.screenControls();

                    _this3.$nextTick(function () {
                      _this3.getTableRight();
                    });
                  };

                  if (!dbres) {
                    _context3.next = 63;
                    break;
                  }

                  PrimitiveList = _this3.$times.getDayAll(startTime, endTime);
                  dateList = JSON.parse(JSON.stringify(PrimitiveList)).reverse();
                  cacheHourData = dbres.content.houreDate == endTime ? dbres.content.todayHoure : {};
                  cacheHourObj = Object.keys(cacheHourData).map(function (i) {
                    return parseInt(i);
                  });
                  list = {};
                  numt = PrimitiveList.findIndex(function (i) {
                    return i == currentDay;
                  }) > -1 && searchHoour.findIndex(function (i) {
                    return parseInt(i) == currentHour;
                  }) > -1;
                  dateList.forEach(function (i) {
                    if (dbres.content.dataNew[i]) {
                      list[i] = dbres.content.dataNew[i];
                    }
                  });
                  queryData = {
                    data: {}
                  };

                  if (queryData.data[currentDay] == undefined) {
                    queryData.data[currentDay] = {};
                  }

                  queryData.data[currentDay] = _objectSpread({}, cacheHourData);

                  if (!numt) {
                    _context3.next = 59;
                    break;
                  }

                  hourDate = {};
                  mathNum = Math.max.apply(null, cacheHourObj);
                  mathNum = mathNum < currentHour ? mathNum + 1 : currentHour;
                  hourDate = {
                    start_hour: cacheHourObj.length ? parseInt(mathNum) < 10 ? "0".concat(parseInt(mathNum)) : mathNum : '00',
                    end_hour: currentHour > PointTimeend ? PointTimeend < 10 ? "0".concat(PointTimeend) : PointTimeend : currentHour
                  };
                  _context3.next = 55;
                  return reqFn(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _this3.searchData), _this3.defaultData()), hourDate), {}, {
                    time: currentDay,
                    days: 1
                  }));

                case 55:
                  queryDataT = _context3.sent;
                  queryData.data[currentDay] = _objectSpread(_objectSpread({}, queryData.data[currentDay]), queryDataT.data.data[currentDay]); // 默认数据

                  defaultData = {
                    "activate_device": 0,
                    "new_device_recharge_amount": 0,
                    "new_device_recharge_num": 0,
                    "new_device_recharge_amountexchange": 0,
                    "recharge_amountexchange": 0,
                    "recharge_amount": 0,
                    "register_num": 0,
                    "login_num": 0,
                    "recharge_num": 0,
                    "online_num": 0,
                    "arppu": 0,
                    "register_recharge_pnum": 0,
                    "register_recharge_amount": 0,
                    "date": endTime
                  };

                  _this3.hourList.forEach(function (i) {
                    var inti = parseInt(i);

                    if (inti <= PointTimeend && inti >= parseInt(_this3.PointTime[0])) {
                      if (!queryData.data[endTime][inti < 10 ? "0".concat(inti) : inti]) {
                        queryData.data[endTime][inti < 10 ? "0".concat(inti) : inti] = _objectSpread({}, defaultData);
                      }
                    }
                  });

                case 59:
                  queryData.data = _objectSpread(_objectSpread({}, list), queryData.data);
                  handleQueryData(queryData);
                  _context3.next = 64;
                  break;

                case 63:
                  return _context3.delegateYield( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                    var querylist, recombination, i, Hds, qd;
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            // let horD = {
                            //   start_hour:this.PointTime[0],
                            //   end_hour:this.PointTime[1]
                            // }
                            // const queryData = await reqFn({  ...this.searchData, ...this.defaultData(),...horD });
                            querylist = [];
                            recombination = {
                              data: {},
                              summary: {}
                            };
                            i = 0;

                          case 3:
                            if (!(i < searchHoour.length)) {
                              _context2.next = 20;
                              break;
                            }

                            Hds = {
                              start_hour: searchHoour[i],
                              end_hour: searchHoour[i]
                            };
                            _context2.next = 7;
                            return reqFn(_objectSpread(_objectSpread(_objectSpread({}, _this3.searchData), _this3.defaultData()), Hds)).catch(function () {
                              _this3.reqLoading = false;
                            });

                          case 7:
                            qd = _context2.sent;

                            if (!(qd.status == 200 || qd.code == 200)) {
                              _context2.next = 15;
                              break;
                            }

                            querylist.push(_objectSpread({}, qd.data));
                            querylist.forEach(function (i) {
                              for (var k in i.data) {
                                var hd = _objectSpread(_objectSpread({}, recombination.data[k]), i.data[k]);

                                if (!recombination.summary[k]) {
                                  recombination.summary[k] = {};
                                }

                                recombination.data[k] = hd;

                                for (var j in hd) {
                                  for (var ji in hd[j]) {
                                    if (!recombination.summary[k][ji]) {
                                      recombination.summary[k][ji] = 0;
                                    }

                                    recombination.summary[k][ji] = recombination.summary[k][ji] + Number(hd[j][ji]);
                                    recombination.summary[k]['arppu'] = recombination.summary[k]['recharge_num'] ? recombination.summary[k]['recharge_amount'] / recombination.summary[k]['recharge_num'] : 0;
                                  }
                                }
                              }
                            });
                            _this3.rawDatatow = _objectSpread({}, recombination);

                            _this3.screenControls();

                            _context2.next = 17;
                            break;

                          case 15:
                            _this3.reqLoading = false;
                            return _context2.abrupt("break", 20);

                          case 17:
                            i++;
                            _context2.next = 3;
                            break;

                          case 20:
                            handleQueryData(recombination);

                          case 21:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  })(), "t0", 64);

                case 64:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    getechart: function getechart() {
      var chartDom = document.getElementById("dataCompareEchart");
      var myChart = echarts.init(chartDom);
      var dataTimeArr = this.dateShowTitle;
      this.dates = Array.from(new Set(this.dates));
      var option;
      option = {
        title: {
          text: this.$t('multiDayRealtimeDataCompare')
        },
        animationDuration: 3000,
        tooltip: {
          trigger: 'axis',
          confine: true,
          axisPointer: {
            type: 'shadow'
          },
          formatter: function formatter(params) {
            var n = params[0].seriesName;
            var astr = '';
            var Na = [params[0].seriesName];
            var width = 0;
            params.forEach(function (item) {
              var index = Na.findIndex(function (i) {
                return i == item.seriesName;
              });

              if (index == -1) {
                Na.push(item.seriesName);
              }
            });
            var i = -1;
            astr += "<div style=\"width:100%\">" + params[0].axisValue + "</div> ";
            params.forEach(function (ele, index) {
              if (n == ele.seriesName) {
                i += 1;
                astr += "<div style=\"width:100%\">" + dataTimeArr[i] + "</div>";
              }

              var wi = ele.seriesName.length * 14 + 70;
              width = width + wi;
              astr += "<div style=\"display: block;height:20px;width:".concat(wi, "px;text-align: left;'}\">\n                        <i style=\"width: 10px;height: 10px;display: inline-block;background: ").concat(ele.color, ";border-radius: 10px;\"></i>\n                        <span>").concat(ele.seriesName, ": ").concat(ele.data, "</span>\n                        </div>");
            });
            var b = "<div style=\"display: flex; width:".concat(width / (i + 1), "px;justify-content: space-around; flex-wrap: wrap;\">") + astr + '</div>';
            return b;
          }
        },
        legend: {
          data: this.originaltableList.map(function (i) {
            return i.name;
          }),
          selected: this.selected,
          width: '80%'
        },
        grid: {
          left: "1%",
          right: "6%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          z: 12,
          show: true,
          orient: 'vertical',
          left: 'right',
          top: 'center',
          feature: {
            mark: {
              show: true
            },
            // dataView: { show: true, readOnly: false },
            // magicType: { show: true, type: ['line', 'bar', 'stack'] },
            restore: {
              show: true
            },
            saveAsImage: {
              show: true
            }
          }
        },
        xAxis: {
          type: "category",
          nameLocation: "middle",
          data: this.dates
        },
        yAxis: {
          type: "value"
        },
        series: this.series_arr
      };
      option && myChart.setOption(option, true);
    },
    exportdata: function exportdata() {
      var columns = [];
      var d = {};
      this.tableList.forEach(function (item, index) {
        item.list.forEach(function (items, indexs) {
          columns.push({
            label: indexs == 0 ? item.label : '',
            prop: items.prop
          });
          d[items.prop] = items.label;
        });
      });
      var data = JSON.parse(JSON.stringify(this.tableData));
      data.unshift(d);
      console.log("this.tableList==", columns);
      console.log("this.tableData", data);
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};